import IconPhoneCallback from '@/shared/icons/NewDesign/IconPhoneCallback'
import ModuleHeader from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleHeader'
import ModuleHeading from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleHeading'
import useScheduleCallbackRailEntry from './useScheduleCallbackRailEntry'

const ScheduleCallbackRailEntry = () => {
  const { hidden, label, statusDotLabel } = useScheduleCallbackRailEntry()

  if (hidden) return null

  return (
    <ModuleHeader>
      <ModuleHeading icon={IconPhoneCallback} moduleKey='schedule-callback' statusDotLabel={statusDotLabel}>
        {label}
      </ModuleHeading>
    </ModuleHeader>
  )
}

export default ScheduleCallbackRailEntry
